<div id="container">
  <div class="item">
    @switch (log.area) {
      @case ('Staff') {
        <app-activity-staff-details (closeDialog)="close()"
        [log]="log"></app-activity-staff-details>
      }
      @case ('AlarmRoute') {
        <app-activity-alarm-route-details (closeDialog)="close()"
        [log]="log"></app-activity-alarm-route-details>
      }
      @case ('AlarmUserGroup') {
        <app-activity-receiver-group-details (closeDialog)="close()" [log]="log"></app-activity-receiver-group-details>
      }
      @case ('Location') {
        <app-activity-location-details (closeDialog)="close()" [log]="log"></app-activity-location-details>
      }
      @case ('EMA') {
        <app-activity-authentication-details (closeDialog)="close()" [log]="log"></app-activity-authentication-details>
      }
      @case ('Digital Supervision') {
        @switch (log.details.targetClass) {
          @case (ActivityTargetClass.ScheduledVisit.toString()) {
            <app-activity-camera-visit-details (closeDialog)="close()"
            [log]="log"></app-activity-camera-visit-details>
          }
          @case (ActivityTargetClass.VisitPause.toString()) {
            <app-activity-camera-pause-details (closeDialog)="close()"
            [log]="log"></app-activity-camera-pause-details>
          }
          <!-- Use camera group details as default element, since some of the older log might not be visible due to missing targetClass element -->
          @default {
            <app-activity-camera-group-details (closeDialog)="close()" 
            [log]="log"></app-activity-camera-group-details>
          }
        }
      }
      @case ('Devices') {
        <app-activity-device-details
          (closeDialog)="close()"
          [log]="log">
        </app-activity-device-details>
      }
    }
  </div>
  <div class="item">
    <i class="fa-solid fa-xmark fa-lg cursorPointer" style="color: #707070" (click)="close()"></i>
  </div>
</div>